import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const clientsListColumns = [
  {
    name: 'id',
    label: 'Identifier',
    hidden: true,
  },
  {
    name: 'id',
    label: 'Identifier',
  },
  {
    name: 'phone',
    label: 'Phone',
  },
  {
    name: 'email',
    label: 'Email',
  },
];

export const clientsListColumnsLabels = {
  email: 'Email',
  phone: 'Phone',
  id: 'Identifier',
};

export const clientsListSchema = {
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  email: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  phone: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const clientsListFiltersSchema = [
  {
    name: 'id',
    type: FilterType.TEXT,
    placeeholder: 'Enter id...',
  },
  {
    name: 'email',
    type: FilterType.TEXT,
    placeeholder: 'Enter email...',
  },
  {
    name: 'phone',
    type: FilterType.TEXT,
    placeeholder: 'Enter phone...',
  },
];
